export default __webpack_public_path__ + "static/media/keto_water.6921b7ba.jpg";